module.exports = __webpack_public_path__ + "static/media/Teppanyaki.d0ddcfa8.jpg";